module.exports = __webpack_public_path__ + "img/personnel_access_feature_01.1976a636.jpg";